import unsignedFetch from '../util/unsignedFetch.js';

export default function* deleteGuestUserLicencesApi(payload) {
  const { userToken, userLicence } = payload;
  const URL = `${__API_BASE__}/open/guest/user-token/${userToken}/user-licence/${userLicence}`;
  return yield unsignedFetch('DeleteGuestUserLicences', URL, 'DELETE', payload);
}
